export const AXIOS_CONSTANTS = {
  REFRESH: {
    COOLDOWN_MS: 10000,
    MAX_FAILURES: 3,
    TIMEOUT_MS: 10000
  },
  CSRF: {
    REFRESH_BUFFER_MS: 5 * 60 * 1000,
    FETCH_TIMEOUT_MS: 5000,
    MAX_RETRY_COUNT: 3,
    EXPIRY_MS: 60 * 60 * 1000
  }
} as const;
